import NiceModal, { useModal } from "@ebay/nice-modal-react";
import {
  useNiceModalLocker,
  NiceModalComponent,
} from "components/context/NiceModalProvider";
import { ModelNoteFormWithView } from "models/notes/NoteForm";

export default NiceModal.create(({ id, ...props }) => {
  const modal = useModal();
  const { setLocked, closeFormIfNotLocked } = useNiceModalLocker(modal);

  return (
    <NiceModalComponent open={modal.visible} onClose={closeFormIfNotLocked}>
      <ModelNoteFormWithView
        setIsDirty={setLocked}
        objectId={id}
        onCancel={modal.hide}
        onDeleted={modal.hide}
        onCreated={modal.hide}
        onFinished={modal.hide}
        {...props}
      />
    </NiceModalComponent>
  );
});
